export default [
  {
    title: 'Component(Sidebar):statistics',
    icon: 'PieChartIcon',
    route: 'statistics',
    action: 'visit',
    resource: 'statistics',
  },
]
